import platform from '../platform';
import { versionCompare } from '../versionCompare';

/** 哈啰出行 app 从6.37.0版本开始 支持孔明 tcp 事件推送, ios 6.38.0版本开始支持，6.37.0版本有 crash */
export default (): boolean => {
  const versionMatch = /version=([\d.]*)/.exec(navigator.userAgent);
  const appVersion = (versionMatch && versionMatch[1]) || '';

  if (platform.isEasyBike) {
    return !!(
      (platform.isAndroid && versionCompare(appVersion, '6.37.0') >= 0)
      || (platform.isIOS && versionCompare(appVersion, '6.38.0') >= 0)
      /** 鸿蒙 暂不支持 暂无计划，后续联系圣宇 */
      || (platform.isHarmony && false)
    );
  }

  return false;
};
